<template>
  <div class="cart-shipping-quote">
    <form class="cart-shipping-quote-form" @submit.prevent="submit">
      <div class="form-group">
        <label for="shipping-quote-zipcode">
          Zipcode
        </label>
        <input
          id="shipping-quote-zipcode"
          ref="zipcodeInput"
          v-model="zipcode"
          type="text"
          class="form-control"
          placeholder="Enter a 5 digit zipcode"
          :disabled="loading"
          required
        />
      </div>
      <div class="form-group">
        <submit-button class="cart-shipping-quote-button" :loading="loading">
          Get Shipping Quote
        </submit-button>
      </div>
    </form>
    <alert-box v-for="alert in alerts" :key="alert.message" :type="alert.type">
      <span v-html="alert.message" />
    </alert-box>
    <shipping-details
      v-if="displayDetails"
      :split-shipment-article-link="splitShipmentArticleLink"
      :still-valid="stillValid"
      :overseas-destination="overseasDestination"
      :shipments="shipments"
    />
  </div>
</template>

<script>
  import axios from "axios"
  import alerts from "mixins/storefront/cart-alerts"
  import ShippingDetails from "./shipping-quote-form/shipping-details"
  import SubmitButton from "./submit-button"

  export default {
    components: {
      ShippingDetails,
      SubmitButton,
    },
    mixins: [alerts],
    props: {
      initialZipcode: {
        type: String,
        required: false,
        default() {
          return ""
        },
      },
      splitShipmentArticleLink: {
        type: String,
        required: true,
      },
      quotePath: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        zipcode: this.initialZipcode,
        stillValid: false,
        overseasDestination: false,
        shipments: [],
        loading: false,
      }
    },
    computed: {
      displayDetails() {
        return !this.loading && this.shipments.length > 0
      },
    },
    created() {
      if (this.zipcode) {
        this.submit()
      }
    },
    methods: {
      submit() {
        this.alerts = []
        if (this.zipcode && !this.zipcode.match(/^\d{5}$/)) {
          this.alert("Zipcode must have exactly five digits", "warning")
          return
        }
        this.loading = true
        axios
          .post(this.quotePath, { zipcode: this.zipcode })
          .then((response) => {
            const data = response.data
            switch (response.status) {
              case 200:
                this.stillValid = data.shipping_quote.still_valid
                // eslint-disable-next-line operator-linebreak
                this.overseasDestination =
                  data.shipping_quote.overseas_destination
                this.shipments = data.shipping_quote.shipments
                data.shipping_quote.warnings.forEach((warning) => {
                  this.alert(warning)
                })
                break
              case 422:
                response.data.errors.forEach((error) => {
                  this.alert(error, "danger")
                })
                break
              default:
                break
            }
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              error.response.data.errors.forEach((message) => {
                this.alert(message, "danger")
              })
            } else {
              this.alert(error.message || error, "danger")
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      update() {
        if (this.zipcode) {
          this.submit()
        }
      },
    },
  }
</script>
